import React, { useState } from "react"
import { useNavigate } from "react-router-dom"
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Input, Spinner, Alert } from "reactstrap"
import { updateEmailVerificationStatus, resendVerificationCode, signIn } from "../../../utils/auth.utils"
import { Auth } from "aws-amplify"
import Users from "../../../utils/apis/users"
import { queryClient } from "../../../utils/functions.utils"
import "../authPages.scss"

const VerifyEmail = ({ isModalOpen, setIsModalOpen, formData }) => {
  const navigate = useNavigate(),
    [code, setCode] = useState(""),
    [loading, setLoading] = useState(false),
    [error, setError] = useState("")
  const [timeLeft, setTimeLeft] = useState(30)
  const [isResendDisabled, setIsResendDisabled] = useState(false)

  const resendVerification = async (event) => {
    event.preventDefault()
    try {
      await resendVerificationCode()

      setIsResendDisabled(true)
      setTimeLeft(30)

      const countdown = setInterval(() => {
        setTimeLeft((prev) => {
          if (prev <= 1) {
            clearInterval(countdown)
            setIsResendDisabled(false)
            return 0
          }
          return prev - 1
        })
      }, 1000)
    } catch (error) {
      setError(error.message)
    }
  }

  const toggle = async () => {
    const email = formData.email
    const password = formData.password
    const userInfo = await signIn({ email, password })
    if (userInfo) {
      queryClient.invalidateQueries({ queryKey: ["useAuthStatus"] })
    }
    setIsModalOpen(false)
  }

  const confirm = async (event) => {
    event.preventDefault()
    try {
      error && setError("")
      setLoading(true)
      await Auth.verifyCurrentUserAttributeSubmit("email", code)
        .then(async () => {
          await updateEmailVerificationStatus(true)
          const user = await Auth.currentAuthenticatedUser()
          await Users.update({ item_id: user.attributes.sub, create_user_subscription: true })
          queryClient.invalidateQueries({ queryKey: ["useAuthStatus"] })
          navigate("/dashboard?signup-success=1")
          setIsModalOpen(false)
        })
        .catch(async (error) => {
          setLoading(false)
          setError(error.message)
        })
    } catch (error) {
      setError(error.message)
      setLoading(false)
    }
  }

  const handleCodeChange = (event) => {
    setCode(event.target.value)
  }

  return (
    <Modal isOpen={isModalOpen} backdrop="static" toggle={toggle}>
      <ModalHeader toggle={toggle}>Verify Email</ModalHeader>
      {error && (
        <Alert color="danger" data-testid="confirm-code-error">
          {error}
        </Alert>
      )}
      <ModalBody>
        Thank you for signing up!
        <p className="py-2">
          Please verify your email to complete the registration. Check your email and paste the verification code below:
        </p>
        <p>
          Didn&apos;t receive a code?{" "}
          <a
            href="!#"
            onClick={resendVerification}
            className={`text-start ${isResendDisabled ? "resend-code-disabled" : "resend-code"}`}
          >
            {isResendDisabled ? `Resend code in ${timeLeft}s` : "Resend code"}
          </a>
        </p>
        <Input
          type="text"
          name="code"
          id="code"
          data-testid="code"
          value={code}
          onChange={handleCodeChange}
          placeholder="e.g. 123456"
        />
      </ModalBody>
      <ModalFooter>
        <Button
          color="primary"
          disabled={code.length < 6}
          data-testid="confirm-code-btn"
          className="flex-grow-1 text-white"
          onClick={confirm}
        >
          {loading && <Spinner size="sm" className="mx-1 text-white" />}Confirm
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default VerifyEmail
